import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import UserManager from './views/UserManager/index';
import SignIn from './views/Users';
import ForgotPassword from './views/Users/presentational/ForgotPassword';
import ResetPassword from './views/Users/presentational/ResetPassword';
import './App.scss';

function App() {
  return (
    <Provider store={store}>
      <Router>
        <Routes>
          <Route exact path="/" element={<SignIn />} />
          <Route path="/dashboards/v2/user-manager" element={<UserManager />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;
